import templateUrl from "emun.customer/scan-badge/badge-scans.htm";
import basicController from "servicestack/basic.controller.properties";
import customerConfig from "emun.customer/customer.config";
import authConfig from "emun.auth/auth.config";
import AutoQuery from "servicestack/auto-query/auto-query";
import ViewBadge from 'emun.customer/scan-badge/view-badge'
import modals from 'webmodals/modals'
import ServiceBus from 'servicestack/service-bus'
import ScanBadge from "emun.customer/scan-badge/scan-badge";
import resolve from 'ioc/resolve'

export class BadgeScansController {
	constructor($scope) {
		const $ctrl = this;
		basicController($ctrl);
		var bus = $ctrl.bus = new ServiceBus($scope);
		$ctrl.config = customerConfig;
		$ctrl.authConfig = authConfig;
	}
	$onInit() {
		const $ctrl = this;
		$ctrl.query = new AutoQuery($ctrl.getAutoQueryOptions());
		resolve('$rootScope').$on("badgeScanned", () => $ctrl.query.load());
	}
	getAutoQueryOptions() {
		const $ctrl = this;
		return {
			url: "QueryBadgeScans.json",
			take: 24,
			pageSize: 24,
			orderBy: "-ScannedOn",
			append: false,
			autoLoad: true,
			//disableQueryString: true,
			filters: [
				{ groupBy: "State",collapsed: true }
			],
			hideLeftNav: true,
			sortOptions: {
				BadgeId: "BadgeId: Low to High",
				"-BadgeId": "BadgeId: High to Low",
				ScannedOn: "ScannedOn: Newest",
				"-ScannedOn": "ScannedOn: Oldest",
				CompanyName: "CompanyName: A to Z",
				"-CompanyName": "CompanyName: Z to A",
				Address: "Address: A to Z",
				"-Address": "Address: Z to A",
				City: "City: A to Z",
				"-City": "City: Z to A",
				State: "State: A to Z",
				"-State": "State: Z to A",
				Zip: "Zip: 1 to 9",
				"-Zip": "Zip: 9 to 1"
			}
		};
	}
	load() {
		const $ctrl = this;
		return $ctrl.query.load.apply($ctrl.query, arguments);
	}
	view(badge) {
		const $ctrl = this;
		ViewBadge.open({ model: { badge: badge } });
	}
	create() {
		const $ctrl = this;
		ScanBadge.open().then((res) => $ctrl.query.load());
	}
}

export default {
	bindings: {},
	controller: BadgeScansController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
};
